import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-catalog" }
const _hoisted_2 = { class: "catalog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      catalogName: _ctx.catalogName,
      brand: _ctx.state.brand,
      breadcrumbs: _ctx.categoryBreadcrumbs
    }, null, 8, ["catalogName", "brand", "breadcrumbs"]),
    _createElementVNode("article", _hoisted_1, [
      _createVNode(_component_Panel, {
        banner: _ctx.banner,
        catalogName: _ctx.catalogName,
        contactURL: _ctx.contactURL
      }, null, 8, ["banner", "catalogName", "contactURL"]),
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_component_router_view, { onUpdateBanner: _ctx.updateBanner }, null, 8, ["onUpdateBanner"])
      ])
    ])
  ], 64))
}